var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "pb-3 pt-1 pr-0 pl-3 break-all",
      attrs: { "grid-list-md": "" },
    },
    [
      _c(
        "v-layout",
        { staticClass: "max-width", attrs: { row: "", wrap: "" } },
        [
          _vm.data.value instanceof Array
            ? [
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(_vm._s(_vm.splitByCapitalLetter(_vm.data.name)) + ":"),
                ]),
                _vm._v(" "),
                _vm.data.value.length == 0
                  ? _c("span", [_vm._v(" None")])
                  : _c(
                      "div",
                      { staticClass: "max-width" },
                      _vm._l(_vm.data.value, function (value, index) {
                        return _c("TreeView", {
                          key: index,
                          attrs: { data: { value } },
                        })
                      }),
                      1
                    ),
              ]
            : _vm.data.value instanceof Object
            ? [
                _vm.data.name
                  ? _c("div", { staticClass: "font-weight-medium max-width" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.data.name) + ":\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.data.value, function (value, name, index) {
                  return _c("TreeView", {
                    key: index,
                    attrs: { data: { value, name, index } },
                  })
                }),
              ]
            : [
                !!_vm.data.name
                  ? [
                      _c("span", { staticClass: "font-weight-medium" }, [
                        _vm._v(
                          _vm._s(_vm.splitByCapitalLetter(_vm.data.name)) + ":"
                        ),
                      ]),
                      _vm._v(
                        "\n         " + _vm._s(_vm.data.value) + "\n      "
                      ),
                    ]
                  : _c("div", { staticClass: "max-width" }, [
                      _vm._v("- " + _vm._s(_vm.data.value) + " "),
                    ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }